module.exports = __webpack_public_path__ + "img/Group_8.93ecc687.png";